module.exports = __webpack_public_path__ + "static/media/nelson_gore.ff9bf55f.gif";